module.exports = __webpack_public_path__ + "static/media/GE.080272a7.svg";